function parseCategoryKeys(category: string | null | undefined): string[] {
  if (!category) return [];
  return category
    .split(",")
    .map((key) => key.trim())
    .filter((key) => key.length > 0);
}

function parseCategoryNames(categoryName: string | null | undefined): string[] {
  if (!categoryName) return [];
  return categoryName
    .split(",")
    .map((name) => name.trim())
    .filter((name) => name.length > 0);
}

function toggleCategorySelection(
  category: string | null,
  categoryName: string | null,
  key: string,
  name: string,
): { category: string | null; categoryName: string | null } {
  const keys = parseCategoryKeys(category);
  const names = parseCategoryNames(categoryName);
  const byKey = new Map<string, string>();
  keys.forEach((existingKey, index) => {
    byKey.set(existingKey, names[index] ?? existingKey);
  });

  if (byKey.has(key)) {
    byKey.delete(key);
  } else {
    byKey.set(key, name);
  }

  const nextKeys = [...byKey.keys()];
  if (nextKeys.length === 0) {
    return { category: null, categoryName: null };
  }

  return {
    category: nextKeys.join(","),
    categoryName: nextKeys.map((existingKey) => byKey.get(existingKey) ?? existingKey).join(", "),
  };
}

function isCategorySelected(category: string | null | undefined, key: string): boolean {
  return parseCategoryKeys(category).includes(key);
}

export { isCategorySelected, parseCategoryKeys, parseCategoryNames, toggleCategorySelection };
